import { ReactNode } from 'react';
import { Flex, Splitter } from 'antd';
import { ModeDocumentsPageType } from '../../../types';
import { DirectoryTreeWrapper } from './DirectoryTreeWrapper';

interface DocumentsPageLayoutProps {
    modeDocument: ModeDocumentsPageType;
    tableMemo: ReactNode;
}

export const DocumentsPageLayout: React.FC<DocumentsPageLayoutProps> = ({ modeDocument, tableMemo }) => {
    return (
        <Flex style={{ height: 'calc(100vh - 324px)' }}>
            <Splitter>
                <Splitter.Panel
                    defaultSize="20%"
                    min="10%"
                    max="40%"
                    style={{
                        padding: '8px',
                        borderRight: '1px solid #f0f0f0',
                    }}
                >
                    <DirectoryTreeWrapper modeDocument={modeDocument} />
                </Splitter.Panel>
                <Splitter.Panel
                    style={{
                        padding: '8px 8px 0px 16px',
                    }}
                >
                    {tableMemo}
                </Splitter.Panel>
            </Splitter>
        </Flex>
    );
};
